import { Controller } from '@hotwired/stimulus';

export class FormSubmitController extends Controller<HTMLFormElement> {
    submit = () => {
        this.element.requestSubmit();
    };
}
